export default __webpack_public_path__ + "static/sisint-a7d68108f213732e5cb565f2f3564e1e.svg";